import React, { useContext, useEffect,useRef,useState } from 'react'
import noteContext from '../Context/Notes/noteContext';
import AddNote from './AddNote';
import Noteitem from './Noteitem';
import { useNavigate} from 'react-router-dom';

function Notes(props) {
  let navigate = useNavigate();
  const context = useContext(noteContext);
  const{notes, getNotes,editNote} = context;
  useEffect(()=>{
    if(localStorage.getItem( 'token')){
      getNotes();
    }
    else{
      navigate("/login");
    }
    
    // eslint-disable-next-line
  },[]);

  const[note,setNote] = useState({id : "",etitle : "",edescription : "", etag : ""})

  const ref = useRef(null);
  const refClose = useRef(null);

  const updateNote = (currentNote)=>{
    ref.current.click();
    setNote({id:currentNote._id, etitle :currentNote.title, edescription : currentNote.description, etag : currentNote.tag});
   
  }

  const handleClick=(e)=>{
    console.log("The node is updating...." , {note});
    editNote(note.id,note.etitle,note.edescription,note.etag);
    refClose.current.click();
    props.showAlert("Note Updated Successfully","success")
  }
  const onChange = (e)=>{
    setNote({...note,[e.target.name] : e.target.value})
  }

  
  return (
    <>
    <AddNote showAlert = {props.showAlert}/>
    
    <button ref={ref} type="button" className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#exampleModal">
      Launch demo modal
    </button>

    <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">Edit note</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <form className='my-3'>
                    <div className="mb-3">
                      <label htmlFor="title" className="form-label">Title</label>
                      <input type="text" className="form-control" id="etitle" name="etitle" value={note.etitle} onChange={onChange} minLength={3} required/>
                      
                    </div>
                    <div className="mb-3">
                      <label htmlFor="description" className="form-label">Description</label>
                      <input type="text" className="form-control" id="edescription" name="edescription" value={note.edescription} onChange={onChange} minLength={5} required/>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="tag" className="form-label">Tag</label>
                      <input type="text" className="form-control" id="etag" name="etag" value={note.etag} onChange={onChange}/>
                    </div>
                    
            </form>
          </div>
          <div className="modal-footer">
            <button ref={refClose} type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button disabled={note.etitle < 3 || note.edescription < 5} type="button" className="btn btn-primary" onClick={handleClick}>Update Note</button>
          </div>
        </div>
      </div>
    </div>
    <div className="row my-3">
      <h1>Your Notes</h1>
      <div className="container">
      {notes.length === 0 && "No notes to be displayed"}
      </div>
      {notes.map((note)=>{
          return <Noteitem key={note._id} updateNote={updateNote} showAlert ={props.showAlert} note={note}/>;
      })}
      </div>
    
    </>
  )
}

export default Notes
